export const name = 'BadUserRequest';
class BadUserRequest extends Error {
	status: Number;
	response: Response;
	constructor(message: string, status: Number, response: Response) {
		super();
		this.message = message;
		this.name = name;
		this.status = status;
		this.response = response;

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, BadUserRequest);
		}
	}
}

export default BadUserRequest;
